export { SampleVhrComponent } from "./SampleVhrComponent";
